export const header = {
    'TR': `HAKKIMIZDA`,
    'Eng': `ABOUT US`
}